function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("rect", {
  x: 0.5,
  width: 28,
  height: 28,
  rx: 4,
  fill: "#252CA0"
});

var _ref3 =
/*#__PURE__*/
React.createElement("path", {
  d: "M22.8333 10.5084V14.0001H12V5.66675H17.9917C21.025 5.66675 22.8333 7.47508 22.8333 10.5084Z",
  fill: "#45E8FF"
});

var _ref4 =
/*#__PURE__*/
React.createElement("path", {
  d: "M12.0013 5.66675V22.3334H11.0096C7.9763 22.3334 6.16797 20.5251 6.16797 17.4917V10.5084C6.16797 7.47508 7.9763 5.66675 11.0096 5.66675H12.0013Z",
  fill: "url(#paint0_linear_15376_461368)"
});

var _ref5 =
/*#__PURE__*/
React.createElement("path", {
  d: "M22.8333 14V17.4917C22.8333 20.525 21.025 22.3333 17.9917 22.3333H12V14H22.8333Z",
  fill: "#0F0B6A"
});

var _ref6 =
/*#__PURE__*/
React.createElement("defs", null, React.createElement("linearGradient", {
  id: "paint0_linear_15376_461368",
  x1: 12.1183,
  y1: 5.66675,
  x2: 3.14846,
  y2: 7.48449,
  gradientUnits: "userSpaceOnUse"
}, React.createElement("stop", {
  stopColor: "#EA4AC7"
}), React.createElement("stop", {
  offset: 1,
  stopColor: "#B960CC"
})));

var SvgWidgetActive = function SvgWidgetActive(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    width: 29,
    height: 28,
    viewBox: "0 0 29 28",
    fill: "none",
    ref: svgRef
  }, props), title ? React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgWidgetActive, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/widget_active.2f820ffb.svg";
export { ForwardRef as ReactComponent };